import React from 'react';

const SvgBd = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BD_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BD_svg__b" fill="#fff">
        <use xlinkHref="#BD_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BD_svg__a" />
      <path fill="#128363" mask="url(#BD_svg__b)" d="M0 0h28v20H0z" />
      <circle fill="#F23C53" mask="url(#BD_svg__b)" cx={12.667} cy={10} r={6} />
    </g>
  </svg>
);

export default SvgBd;
